import API from '@aws-amplify/api'
import { graphqlOperation } from '@aws-amplify/api-graphql'
import { faCrown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { getLeaderboard } from '../../graphql/queries'
import { pinaYellow } from '../../constants/colors'

const Styles = styled.div`
    max-width: 860px;
    margin: 24px auto;
    padding: 0 16px;

    h2 {
        font-size: 1.4em;
        font-weight: 600;
        margin-bottom: 20px;
    }
`

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    background: rgba(30,30,30,0.92);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);

    th, td {
        padding: 10px 14px;
        text-align: left;
        color: white;
    }

    th {
        background: rgba(0,0,0,0.25);
        font-size: 0.8em;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-weight: 600;
    }

    tbody tr:not(:last-child) {
        border-bottom: 1px solid rgba(255,255,255,0.08);
    }

    tbody tr:hover {
        background: rgba(255,255,255,0.06);
    }

    td a {
        color: white;
        text-decoration: none;
        font-weight: 500;
    }

    td a:hover {
        text-decoration: underline;
    }

    .crown {
        color: ${pinaYellow};
        margin-right: 6px;
    }

    .num {
        color: rgba(255,255,255,0.5);
        font-size: 0.9em;
    }
`

export default function LeaderboardPage() {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        API.graphql(graphqlOperation(getLeaderboard))
            .then(res => setData(res.data))
            .catch(err => setError(err))
            .finally(() => setLoading(false))
    }, [])

    return (
        <Styles>
            <h2>Leaderboard</h2>
            {loading && <p style={{ color: 'white' }}>Loading...</p>}
            {error && <p style={{ color: 'white' }}>Failed to load leaderboard.</p>}
            {data && (
                <Table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>User</th>
                            <th>Posts</th>
                            <th>Avg</th>
                            <th>Min</th>
                            <th>Max</th>
                            <th>Favorite Location</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.getLeaderboard.map((entry, i) => (
                            <tr key={entry.username}>
                                <td className='num'>{i + 1}</td>
                                <td>
                                    {i === 0 && <FontAwesomeIcon className='crown' icon={faCrown}/>}
                                    <a href={`/users/${entry.username}`}>{entry.username}</a>
                                </td>
                                <td>{entry.postCount}</td>
                                <td>{entry.avgOverall.toFixed(1)}</td>
                                <td>{entry.minOverall}</td>
                                <td>{entry.maxOverall}</td>
                                <td>{entry.favoriteLocation ? `${entry.favoriteLocation} (${entry.favoriteLocationCount}x)` : '—'}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Styles>
    )
}
